import React, { useEffect, useState } from "react";

import * as Yup from "yup";
import { Buffer } from "buffer";
import { Form, Formik } from "formik";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { isValidPhoneNumber } from "react-phone-number-input";

import Button from "@mui/material/Button";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Unstable_Grid2";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import { Box, Paper, Stack, Typography } from "@mui/material";

import { Loader } from "../common/loader";
import { CUSTOMER_HOME_PATH, ROLES } from "../helpers/constants";
import FinalStepCompleted from "./finalStepCompleted";
import ContcatAdminSupport from "../common/ContcatAdminSupport";
import BeneficiaryV2 from "./SignupTaiwindComponents/BeneficiaryV2";
import CustomPhoneNumberInput from "../common/CustomPhoneNumberInput";
import { relationships } from "./SignupTaiwindComponents/BeneficiaryV2";
import { userSigupAction } from "../../redux/slices/user/userSignUpSlice";
import { userProfileAction } from "../../redux/slices/user/userProfileSlice";
import HubspotCookieBreakerInput from "../common/HubspotCookieBreakerInput";
import {
  clearSignupResumeMarkers,
  clearSignupVerificationState,
  decryptPayload,
  encryptPayload,
  getObjLength,
  getSignupCompletionRoute,
  getSignupLoginCredentials,
  setStanupPopupCountIfEligible,
  shouldCompleteSignupAfterIdVerification,
} from "../helpers/utils";
import { propertyRiskManagementAction } from "../../redux/slices/admin/property-risk-management/propertyRiskManagementSlice";

import "./signup.scss";

const initialValues = {
  first_name: "",
  last_name: "",
  relation: "",
  phone: "",
  email: "",
};

const validationSchema = Yup.object().shape({
  first_name: Yup.string("Please enter your First Name.")
    .trim("The First name cannot include leading and trailing spaces")
    .strict(true)
    .required("First Name is required"),
  last_name: Yup.string("Please enter your Last name.")
    .trim("The Last name cannot include leading and trailing spaces")
    .strict(true)
    .required("Last Name is required"),
  relation: Yup.string("Please enter your Relation.")
    .trim("The Relation cannot include leading and trailing spaces")
    .strict(true)
    .required("Relation is required"),
  // Optional: validate format only when a value is present
  phone: Yup.string()
    .nullable()
    .optional()
    .test("valid-phone", "Please enter a valid phone number", (value) => {
      if (!value || String(value).trim().length === 0) {
        return true;
      }
      const phone = String(value).trim();
      return (
        isValidPhoneNumber(phone) ||
        isValidPhoneNumber(phone, "US") ||
        isValidPhoneNumber(phone, "IN")
      );
    }),
  email: Yup.string()
    .trim()
    .nullable()
    .optional()
    .test("valid-email", "Please enter a valid email address", (value) =>
      !value || String(value).trim().length === 0
        ? true
        : /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value)),
    ),
});

const BeneficiaryForm = ({
  finalScreen,
  HideSkipBtn = () => {},
  errorPopup,
  reduceErrorCount,
  isIOS,
  isAdminCreateUser = false,
  admin_id = undefined,
  user_id = undefined,
  completedProcess = () => {},
  onBtnClick = () => {},
  skipBenificiary = () => {},
  isBeneficiariesSkip = false,
  isResumeSignup = false,
  isTailwindComponent = false,
  isServiceProvider = false,
  handleSkip = () => {},
  category = "complete_protection",
  userEmail = undefined,
  // /create-account wizard: send-welcome-email already ran after the Security
  // PIN. Other flows leave these at their defaults and behave as before.
  welcomeEmailAfterPin = false,
  maxBeneficiaries = 2,
}) => {
  const dispatch = useDispatch();

  const [addNewBeneficiary, setAddNewBeneficiary] = useState(false);
  const [submit, setSubmit] = useState(finalScreen);
  // True once the user presses Next / Skip. With welcomeEmailAfterPin the mail
  // result is already in the store on mount, so completion effects wait for this.
  const [finishRequested, setFinishRequested] = useState(false);
  // const [isSendMailModalOpen, setIsSendMailModalOpen] = useState(false);

  const crerateAccData = useSelector(
    (state) => state.signUpUser?.createAccResponse,
  );

  const {
    beneficiaryList,
    beneficiaryLoader,
    beneficiaryError,
    sendMailDetails,
    resumeProcessResponse,
    userSignupDetails,
    userSignInDetails,
  } = useSelector((state) => state.signUpUser);
  const userIdFromSession = JSON.parse(localStorage.getItem("user_Id"));
  const userDataFromSession = JSON.parse(
    localStorage.getItem("userSignupDetails"),
  );

  const navigate = useNavigate();

  const earlyWelcomeSent =
    welcomeEmailAfterPin && Boolean(sendMailDetails?.success);

  const onSubmit = (values, errors) => {
    dispatch(
      userSigupAction.addBeneficiaryDetails({
        url: "beneficiaries",
        data: {
          user_id:
            (getObjLength(crerateAccData)
              ? crerateAccData.data?.user_id
              : userIdFromSession) || user_id,
          from_admin: isAdminCreateUser ? 1 : undefined,
          admin_id: isAdminCreateUser ? admin_id : undefined,
          // userData?.user_id,
          ...values,
          // Backend writes json_last_step verbatim; once SEND_WELCOME_EMAIL is
          // stored, sending SAVE_BENEFICIARIES would rewind the signup step.
          ...(earlyWelcomeSent
            ? {}
            : { step: 7, step_key: "SAVE_BENEFICIARIES" }),
        },

        token: true,
      }),
    );
    setAddNewBeneficiary(false);
  };

  console.log(userSignupDetails, "Decoded String:", userDataFromSession);

  const resolveSignupCategory = () =>
    decryptPayload(localStorage.getItem("category")) || category;

  const isCompleteProtectionSignup = () =>
    resolveSignupCategory() === "complete_protection";

  const triggerSignupAutoLogin = () => {
    const loginToken = localStorage.getItem("setLoginUserToken");
    if (isAdminCreateUser || loginToken) {
      return;
    }

    // Native already logged in after OTP and injected authToken into the webview.
    if (
      (isIOS === "ios" || isIOS === "android") &&
      localStorage.getItem("authToken")
    ) {
      return;
    }

    const { email, password } = getSignupLoginCredentials();
    if (!email || !password) {
      return;
    }

    dispatch(
      userSigupAction.userLoginData({
        url: "login",
        data: {
          email,
          password,
          auto_login: 1,
        },
      }),
    );
  };

  const completeSignupSession = () => {
    const uID =
      userSignInDetails?.data?.user?.id ||
      userSignInDetails?.data?.user?.user_id ||
      JSON.parse(localStorage.getItem("user_Id") || "null");

    if (uID) {
      localStorage.setItem("uID", String(uID));
    }

    dispatch(propertyRiskManagementAction.resetPropertyRiskManagementState());
    localStorage.setItem("roles", encryptPayload(ROLES.customer));
    setStanupPopupCountIfEligible(resolveSignupCategory());
    localStorage.setItem("paymentPopup", 0);
    clearSignupVerificationState();
    clearSignupResumeMarkers();
    dispatch(
      userProfileAction.userProfileData({
        url: "profile",
        token: true,
      }),
    );

    navigate(CUSTOMER_HOME_PATH, { replace: true });
  };

  const sendWelcomeMailHandler = () => {
    // Already sent after the Security PIN — the completion effects run off the
    // stored result. Falls through as a safety net when that call is not known
    // to have succeeded (failed, or page refreshed / resumed).
    if (earlyWelcomeSent) {
      return;
    }
    if (isCompleteProtectionSignup()) {
      dispatch(
        userSigupAction.sendSignUpMail({
          url: "send-welcome-email",
          data: {
            user_id:
              (getObjLength(crerateAccData)
                ? crerateAccData.data?.user_id
                : userIdFromSession) || user_id,
            from_admin: isAdminCreateUser ? 1 : undefined,
            admin_id: isAdminCreateUser ? admin_id : undefined,
            step: 7,
            step_key: "SEND_WELCOME_EMAIL",
          },
        }),
      );
      return;
    }

    triggerSignupAutoLogin();
    if (isAdminCreateUser) {
      onBtnClick();
    }
  };

  const navigateAfterSignupCompletion = () => {
    if (isResumeSignup || isAdminCreateUser) {
      return;
    }

    if (
      shouldCompleteSignupAfterIdVerification() ||
      isCompleteProtectionSignup()
    ) {
      return;
    }

    navigate(getSignupCompletionRoute(), { replace: false });
  };

  const completeIdVerifiedSignup = () => {
    if (
      !shouldCompleteSignupAfterIdVerification() ||
      !userSignInDetails?.success ||
      !localStorage.getItem("authToken")
    ) {
      return;
    }

    const uID = userSignInDetails?.data?.user?.id;
    if (uID) {
      localStorage.setItem("uID", uID);
    }

    dispatch(propertyRiskManagementAction.resetPropertyRiskManagementState());
    localStorage.setItem("roles", encryptPayload(ROLES.customer));
    setStanupPopupCountIfEligible(resolveSignupCategory());
    localStorage.setItem("paymentPopup", 0);
    clearSignupVerificationState();
    clearSignupResumeMarkers();
    dispatch(
      userProfileAction.userProfileData({
        url: "profile",
        token: true,
      }),
    );

    navigate(CUSTOMER_HOME_PATH, { replace: true });
  };

  const handleNextBtn = () => {
    setFinishRequested(true);
    sendWelcomeMailHandler();
    if (!shouldCompleteSignupAfterIdVerification()) {
      setSubmit(true);
    }
    navigateAfterSignupCompletion();
    // dispatch(userSigupAction.clearData());
    // localStorage.removeItem("user_Id");
    // localStorage.removeItem("currentStep");
    // localStorage.removeItem("skip");
  };

  // const handleClose = () => {
  //   setIsSendMailModalOpen(false);
  //   setSubmit(true);
  //   dispatch(userSigupAction.clearData());
  // };

  const FieldStyle = {
    borderRadius: "3px",
  };
  const OwnerCardStyle = {
    background: "#FFFFFF",
    boxShadow: "0px 17.0825px 39.8592px -5.69417px rgba(0, 0, 0, 0.15);",
    borderRadius: "8px",
    py: 2.5,
    px: 3,
    color: "#0D120B",
    width: "100%",
    height: "100%",
  };
  const RelationMenuProps = {
    PaperProps: {
      style: { maxHeight: 48 * 4.5 + 8, width: 250 },
    },
  };
  useEffect(() => {
    if (!isAdminCreateUser && finalScreen) {
      handleNextBtn();
    }
  }, [finalScreen]);

  useEffect(() => {
    if (welcomeEmailAfterPin && !finishRequested) {
      return;
    }
    if (
      userSignInDetails?.success &&
      localStorage.getItem("authToken") &&
      !isAdminCreateUser &&
      !isResumeSignup
    ) {
      if (shouldCompleteSignupAfterIdVerification()) {
        completeIdVerifiedSignup();
        return;
      }

      if (isCompleteProtectionSignup() && submit) {
        completeSignupSession();
      }
    }
  }, [userSignInDetails, submit, finishRequested]);
  useEffect(() => {
    if (isAdminCreateUser && isBeneficiariesSkip) {
      setSubmit(true);
      sendWelcomeMailHandler();
    }
  }, [isBeneficiariesSkip]);

  useEffect(() => {
    console.log(beneficiaryError, "beneficiaryList==>", beneficiaryList);
    if (beneficiaryList.length > 0) {
      console.log("button skiped==>");
      HideSkipBtn(false);
    }
  }, [beneficiaryList, beneficiaryError]);

  useEffect(() => {
    if (!getObjLength(sendMailDetails) || isAdminCreateUser) {
      return;
    }
    // Mail result pre-exists on mount here; do not auto-login / leave the
    // wizard until the user finishes the Beneficiary step.
    if (welcomeEmailAfterPin && !finishRequested) {
      return;
    }

    if (sendMailDetails?.success && isCompleteProtectionSignup()) {
      triggerSignupAutoLogin();
    }

    const loginToken = localStorage.getItem("setLoginUserToken");
    if (loginToken?.length > 0) {
      localStorage.setItem("authToken", loginToken);
      localStorage.setItem("authorised", true);
      localStorage.setItem("roles", encryptPayload(ROLES.customer));
      setStanupPopupCountIfEligible(resolveSignupCategory());
      localStorage.setItem("paymentPopup", 0);
      dispatch(propertyRiskManagementAction.resetPropertyRiskManagementState());
      if (
        localStorage.getItem("authToken") &&
        !shouldCompleteSignupAfterIdVerification() &&
        submit
      ) {
        clearSignupResumeMarkers();
        navigate(CUSTOMER_HOME_PATH, { replace: true });
      }
    }
  }, [sendMailDetails, submit, finishRequested]);

  return (
    <>
      {!submit ? (
        isTailwindComponent ? (
          <BeneficiaryV2
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
            handleNextBtn={handleNextBtn}
            handleSkip={() => {
              // Admin/SP create wires skipBenificiary; customer signup wires handleSkip.
              skipBenificiary();
              handleSkip();
            }}
            userEmail={userEmail}
            isServiceProvider={isServiceProvider}
            maxBeneficiaries={maxBeneficiaries}
          />
        ) : (
          <>
            <Box
              className="d-flex justify-content-center"
              sx={{ minWidth: "300px" }}
            >
              <Stack direction="column" alignItems="center" pb={3}>
                <Typography align="center" variant="h5" className="fw-600">
                  {isAdminCreateUser && !isResumeSignup ? "User's " : null}
                  Beneficiary Form
                </Typography>
                <Typography align="center" variant="body1" className="pt-2">
                  This beneficiary data will display on{" "}
                  {isAdminCreateUser ? "User's" : "your"} profile
                </Typography>
                <Grid
                  container
                  spacing={3}
                  alignItems="stretch"
                  pt={3}
                  sx={{ width: "100%" }}
                >
                  {beneficiaryList?.map((person, key) => (
                    <Grid
                      key={key}
                      xs={12}
                      sm={beneficiaryList?.length > 1 ? 6 : 12}
                      sx={{ display: "flex" }}
                    >
                      <Paper
                        sx={OwnerCardStyle}
                        className={`${isAdminCreateUser ? "text-start" : ""}`}
                      >
                        <Typography
                          variant="subtitle2"
                          sx={{
                            mb: 1.5,
                            fontWeight: 700,
                            fontSize: "14px",
                            color: "#15be53",
                          }}
                        >
                          Beneficiary {key + 1}
                        </Typography>
                        {[
                          { label: "First Name", value: person?.first_name },
                          { label: "Last Name", value: person?.last_name },
                          { label: "Relation", value: person?.relation },
                          ...(person?.phone
                            ? [{ label: "Phone", value: person.phone }]
                            : []),
                          ...(person?.email
                            ? [{ label: "Email", value: person.email }]
                            : []),
                        ].map(({ label, value }) => (
                          <Box
                            key={label}
                            sx={{
                              display: "flex",
                              gap: 1,
                              mb: 0.75,
                              flexWrap: "wrap",
                            }}
                          >
                            <Typography
                              variant="body2"
                              sx={{
                                fontWeight: 600,
                                color: "#555",
                                minWidth: "80px",
                                flexShrink: 0,
                              }}
                            >
                              {label}:
                            </Typography>
                            <Typography
                              variant="body2"
                              sx={{
                                color: "#0D120B",
                                wordBreak: "break-word",
                                flex: 1,
                              }}
                            >
                              {value}
                            </Typography>
                          </Box>
                        ))}
                      </Paper>
                    </Grid>
                  ))}
                  {/* {beneficiaryList?.map((person) => (
              <>
                <Grid item xs={12} sm={12} md={4} lg={4}>
                  {person?.first_name}
                </Grid>
                <Grid item xs={12} sm={12} md={4} lg={4}>
                  {person?.last_name}
                </Grid>
                <Grid item xs={12} sm={12} md={4} lg={4}>
                  {person?.relation}
                </Grid>
              </>
            ))} */}
                </Grid>
              </Stack>
            </Box>
            <Box className="d-flex justify-content-center">
              <Formik
                enableReinitialize
                validateOnChange
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={onSubmit}
              >
                {({ values, setFieldValue, touched, errors, resetForm }) => {
                  return (
                    <Form className="form_modal" id="signup-beneficiary-form">
                      {/* Block HubSpot's browser form capture: the beneficiary's name/email/phone
                          would otherwise be merged into the owner's contact. The beneficiary is
                          sent to HubSpot by the backend instead. */}
                      <HubspotCookieBreakerInput isNonHubSpotForm />

                      <Grid
                        container
                        rowSpacing={1}
                        columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                      >
                        {((addNewBeneficiary && beneficiaryList.length > 0) ||
                          (!addNewBeneficiary &&
                            beneficiaryList.length === 0)) && (
                          <>
                            <Grid xs={12} md={6} px={1} pb={1}>
                              <TextField
                                id="firstName"
                                className="sign-textField "
                                // id="outlined-basic"
                                label="First name"
                                name="first_name"
                                value={values?.first_name}
                                variant="outlined"
                                sx={FieldStyle}
                                InputLabelProps={{
                                  style: {
                                    fontWeight: "400",
                                    fontSize: "14px",
                                    lineHeight: "20px",
                                    color: "#00000075",
                                  },
                                }}
                                onChange={(event) => {
                                  setFieldValue(
                                    "first_name",
                                    event.target.value,
                                  );
                                }}
                                helperText={
                                  touched.first_name && errors.first_name
                                }
                                error={
                                  touched.first_name &&
                                  Boolean(errors.first_name)
                                }
                              />
                            </Grid>
                            <Grid xs={12} md={6} px={1} pb={1}>
                              <TextField
                                id="lastName"
                                className="sign-textField "
                                // id="outlined-basic"
                                label="Last name"
                                name="last_name"
                                variant="outlined"
                                sx={FieldStyle}
                                InputLabelProps={{
                                  style: {
                                    fontWeight: "400",
                                    fontSize: "14px",
                                    lineHeight: "20px",
                                    color: "#00000075",
                                  },
                                }}
                                value={values?.last_name}
                                onChange={(event) => {
                                  setFieldValue(
                                    "last_name",
                                    event.target.value,
                                  );
                                }}
                                helperText={
                                  touched.last_name && errors.last_name
                                }
                                error={
                                  touched.last_name && Boolean(errors.last_name)
                                }
                              />
                            </Grid>
                            <Grid xs={12} md={6} px={1} pb={1}>
                              <FormControl
                                fullWidth
                                className="sign-textField"
                                error={
                                  touched.relation && Boolean(errors.relation)
                                }
                              >
                                <InputLabel
                                  shrink
                                  id="relationLabel"
                                  style={{ color: "#00000075" }}
                                >
                                  Relation
                                </InputLabel>
                                <Select
                                  labelId="relationLabel"
                                  id="relation"
                                  name="relation"
                                  label="Relation"
                                  variant="outlined"
                                  value={values?.relation || ""}
                                  onChange={(event) =>
                                    setFieldValue(
                                      "relation",
                                      event.target.value,
                                    )
                                  }
                                  MenuProps={RelationMenuProps}
                                  displayEmpty
                                  sx={FieldStyle}
                                  className="text-start"
                                >
                                  <MenuItem disabled value="">
                                    <span style={{ color: "#00000075" }}>
                                      Select relationship
                                    </span>
                                  </MenuItem>
                                  {relationships.map((rel) => (
                                    <MenuItem key={rel} value={rel}>
                                      {rel}
                                    </MenuItem>
                                  ))}
                                </Select>
                                {touched.relation &&
                                  Boolean(errors.relation) && (
                                    <FormHelperText sx={{ color: "#d32f2f" }}>
                                      {touched.relation && errors.relation}
                                    </FormHelperText>
                                  )}
                              </FormControl>
                            </Grid>

                            {/* Contact Information (optional) */}
                            <Grid xs={12} md={12} px={1} pb={1}>
                              <Typography
                                className="text-muted-foreground"
                                variant="body2"
                                sx={{ mt: 1, mb: 1, fontWeight: 500 }}
                              >
                                Contact Information
                              </Typography>
                            </Grid>

                            <Grid xs={12} md={6} px={1} pb={1}>
                              <CustomPhoneNumberInput
                                name="phone"
                                placeholder="Mobile Phone (optional)"
                                values={values}
                                touched={touched}
                                setFieldValue={setFieldValue}
                                errors={errors}
                                otherProps={{
                                  onChange: (event) => {
                                    setFieldValue("phone1", event);
                                    setFieldValue("phone", event);
                                    if (!event) {
                                      setFieldValue("phone1", "");
                                    }
                                  },
                                }}
                              />
                            </Grid>

                            <Grid xs={12} md={6} px={1} pb={1}>
                              <TextField
                                id="emailAddress"
                                className="sign-textField "
                                label="Email Address (optional)"
                                name="email"
                                variant="outlined"
                                sx={FieldStyle}
                                value={values?.email || ""}
                                onChange={(event) => {
                                  setFieldValue("email", event.target.value);
                                }}
                                helperText={touched.email && errors.email}
                                error={touched.email && Boolean(errors.email)}
                              />
                            </Grid>
                          </>
                        )}

                        <Grid
                          xs={12}
                          md={12}
                          px={1}
                          pb={1}
                          className={`${
                            isAdminCreateUser
                              ? "d-flex justify-content-between align-items-center"
                              : ""
                          }`}
                        >
                          {isAdminCreateUser &&
                            beneficiaryList.length === 0 && (
                              <div className="action-btn mt-5">
                                <Button
                                  className="admin_skip_btn"
                                  onClick={skipBenificiary}
                                >
                                  Skip
                                </Button>
                              </div>
                            )}
                          <div className="action-btn mt-5">
                            {addNewBeneficiary ? (
                              <Button
                                className="stepBtn"
                                variant="contained"
                                onClick={() => {
                                  setAddNewBeneficiary(false);
                                }}
                              >
                                Cancle
                              </Button>
                            ) : (
                              <Button
                                disabled={
                                  beneficiaryList.length === 0 ||
                                  beneficiaryList.length >= maxBeneficiaries
                                }
                                className="stepBtn"
                                variant="contained"
                                onClick={() => {
                                  resetForm();
                                  setAddNewBeneficiary(true);
                                }}
                              >
                                Add
                              </Button>
                            )}
                            {(!addNewBeneficiary &&
                              beneficiaryList.length > 0) ||
                            (!addNewBeneficiary &&
                              beneficiaryList.length >= maxBeneficiaries) ||
                            beneficiaryList?.length >= maxBeneficiaries ? (
                              <Button
                                onClick={() => handleNextBtn()}
                                className="stepBtn"
                                variant="contained"
                              >
                                Next
                              </Button>
                            ) : (
                              <Button
                                type="submit"
                                className="stepBtn"
                                variant="contained"
                              >
                                Save
                              </Button>
                            )}
                          </div>
                        </Grid>
                      </Grid>
                      {beneficiaryError && (
                        <p className="text-center text-danger">
                          {beneficiaryError}
                        </p>
                      )}
                    </Form>
                  );
                }}
              </Formik>
            </Box>
          </>
        )
      ) : (
        <>
          <Typography sx={{ mt: 2, mb: 1 }}>
            <FinalStepCompleted
              isIOS={isIOS}
              isAdminCreateUser={isAdminCreateUser}
              isServiceProvider={isServiceProvider}
              completedProcess={completedProcess}
              isTailwindComponent={isTailwindComponent && !isResumeSignup}
            />
          </Typography>
        </>
      )}
      <Loader open={beneficiaryLoader} />
      {errorPopup && (
        <ContcatAdminSupport
          message={beneficiaryError}
          errorPopup={errorPopup}
          reduceErrorCount={reduceErrorCount}
        />
      )}
      {/* {isSendMailModalOpen && (
        <SendMailModal
          open={isSendMailModalOpen}
          handleClose={handleClose}
          sendWelcomMailReqAgain={sendWelcomeMailHandler}
        />
      )} */}
    </>
  );
};

export default BeneficiaryForm;
